<button mat-raised-button color="basic" class="stop-all-processes-button"
    (click)="stopAllProcesses()">{{buttonLabel}}</button>